import { useAppConfigContext } from '@/context/AppConfig';
import { Button, Stack } from '@/theme/components';
import { Text, styled, Modal, Icons } from '@/theme/index';
import { HorizontalLine } from '../../components';

const DiscardChangesModalContainer = styled(Modal)(({ theme }) => ({
  overflowX: 'hidden',
  '.MuiDialogTitle-root': {
    display: 'flex',
    padding: `0 ${theme.spacing(3)}`,
    margin: `${theme.spacing(2.5)} 0 0 0`,
  },
  '.discard-modal': {
    overflowX: 'hidden',
    maxWidth: 'none',
  },
  '.MuiDialogContent-root': {
    width: 'auto',
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.up('sm')]: {
      width: '585px',
    },
  },
}));

const AdjustedStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse',
    padding: `${theme.spacing(1)} 0`,
  },
}));

const AdjustedButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(1),
    width: '100%',
  },
}));

interface DiscardChangesModalProps {
  open: boolean;
  onClose: () => void;
  openEditModal: () => void;
}

export const DiscardChangesModal = ({
  open,
  onClose,
  openEditModal,
}: DiscardChangesModalProps) => {
  const { trackEvent } = useAppConfigContext();

  const handleDiscardChanges = () => {
    trackEvent(
      'edit property details exit flow',
      'engagement click',
      'edit property details flow'
    );
    onClose();
  };

  return (
    <DiscardChangesModalContainer
      open={open}
      onClose={onClose}
      classes={{ paper: 'discard-modal' }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
        }}
      >
        <Text
          variant="h2"
          sx={{
            marginBottom: '0',
          }}
        >
          Unsaved Changes?
        </Text>
        <Icons.Close
          onClick={onClose}
          sx={{
            cursor: 'pointer',
          }}
        />
      </Stack>
      <HorizontalLine />
      <Stack>
        <Text variant="h3" color={(theme) => theme.palette.success.main}>
          There are unsaved changes.
        </Text>
        <br />
        <Text>Are you sure you want to discard your changes?</Text>
        <HorizontalLine />
        <AdjustedStack>
          <AdjustedButton
            variant="outlined"
            onClick={openEditModal}
            color="success"
          >
            Go Back
          </AdjustedButton>
          <Button
            variant="contained"
            onClick={handleDiscardChanges}
            color="success"
          >
            Discard Changes
          </Button>
        </AdjustedStack>
      </Stack>
    </DiscardChangesModalContainer>
  );
};
